// Ported from Studio Playground frontend/src/utils/boothAssist.js.
import { boothSectionLabel } from './sectionMap';

const clean = (value, length) => String(value || '').trim().slice(0, length);

const focusedSectionIndex = (sections, focusedLine) => {
  if (Number.isInteger(focusedLine?.section)) return focusedLine.section;
  return sections.findIndex((section) => (
    (focusedLine?.sectionId && section.id === focusedLine.sectionId)
    || (focusedLine?.markerId && section.marker_id === focusedLine.markerId)
  ));
};

export const buildAssistBody = (sheet, focusedLine, move, extra = {}) => {
  const sections = sheet?.sections || [];
  const requestedSection = focusedSectionIndex(sections, focusedLine);
  const sectionIndex = requestedSection >= 0 ? requestedSection : 0;
  const section = sections[sectionIndex] || { label: 'Hook', lines: [] };
  const requestedLine = focusedLine?.lineIndex ?? focusedLine?.line;
  const lineIndex = Number.isInteger(requestedLine) ? requestedLine : -1;
  const activeLine = lineIndex >= 0 ? section.lines?.[lineIndex] : null;
  const before = lineIndex > 0
    ? (section.lines || [])
      .slice(0, lineIndex)
      .map((line) => clean(line.text, 140))
      .filter(Boolean)
      .slice(-4)
    : [];
  const body = {
    move,
    section: boothSectionLabel(section.label),
    line: clean(activeLine?.text, 140),
    before,
    vibe: '',
  };
  if (move === 'rhymes_that_mean') {
    body.target_word = clean(extra.target_word, 40);
    body.meaning = clean(extra.meaning, 80);
  }
  return body;
};
